export type PassportVerdict = "passport_page" | "id_card" | "drivers_licence" | "unreadable" | "other";
export type IdPhotoVerdict = "portrait_photo" | "document_photo" | "multiple_people" | "unreadable" | "other";

export const VERDICT_LABELS: Record<string, string> = {
  passport_page: "Passport page",
  id_card: "ID card",
  drivers_licence: "Driver's licence",
  unreadable: "Unreadable",
  other: "Other document",
};

export const ID_PHOTO_VERDICT_LABELS: Record<string, string> = {
  portrait_photo: "Portrait photo",
  document_photo: "Photo of a document",
  multiple_people: "Not a single portrait",
  unreadable: "Unreadable",
  other: "Not a portrait photo",
};

export function verdictLabel(verdict?: string | null): string {
  if (!verdict) return "Not checked";
  return VERDICT_LABELS[verdict] || verdict;
}

export function idPhotoVerdictLabel(verdict?: string | null): string {
  if (!verdict) return "Not checked";
  return ID_PHOTO_VERDICT_LABELS[verdict] || verdict;
}

/** Student-facing message explaining why an ID photo was rejected. */
export function idPhotoRejectionMessage(verdict?: string | null): string {
  switch (verdict) {
    case "document_photo":
      return "This looks like a photo of a document, not a portrait photo. Please upload a head-and-shoulders photo of yourself (like a passport photo).";
    case "multiple_people":
      return "We can see more than one person, or your face is too small. Please upload a head-and-shoulders photo of just yourself.";
    case "unreadable":
      return "We couldn't see your face clearly — the photo is too blurry, dark or far away. Please upload a clearer head-and-shoulders photo.";
    default:
      return "This doesn't look like a passport-style photo of a person. Please upload a head-and-shoulders photo of yourself, facing the camera.";
  }
}

/** True when the automatic check flagged the ID photo as probably not a portrait photo. */
export function needsIdPhotoAttention(sub: {
  id_doc_verdict?: string | null;
  id_doc_verified_by?: string | null;
}): boolean {
  if (!sub?.id_doc_verdict) return false;
  if (sub.id_doc_verified_by) return false;
  return sub.id_doc_verdict !== "portrait_photo";
}


/** True when the automatic check flagged the upload as probably not a passport page. */
export function needsPassportAttention(sub: {
  passport_doc_verdict?: string | null;
  passport_doc_verified_by?: string | null;
}): boolean {
  if (!sub?.passport_doc_verdict) return false;
  if (sub.passport_doc_verified_by) return false;
  return sub.passport_doc_verdict !== "passport_page";
}

export function confidencePct(c?: number | null): string | null {
  if (c === null || c === undefined) return null;
  return `${Math.round(c * 100)}%`;
}
